export const categories = [
  {
    id: 'xianshi-miaosha',
    name: '限时秒杀',
    slug: 'xianshi-miaosha',
    description: '每日限时超低价秒杀，手慢无！精选爆款好物限时抢购',
    icon: 'ri-flashlight-line',
  },
  {
    id: 'gouwu-fanxian',
    name: '购物返现',
    slug: 'gouwu-fanxian',
    description: '下单即返现，真实到账。覆盖各大电商平台购物返利',
    icon: 'ri-refund-2-line',
  },
  {
    id: 'huiyuan-tequan',
    name: '会员特权',
    slug: 'huiyuan-tequan',
    description: '各大平台会员专属福利，视频、音乐、购物会员超值购',
    icon: 'ri-vip-crown-line',
  },
  {
    id: 'shenghuo-youhui',
    name: '生活优惠',
    slug: 'shenghuo-youhui',
    description: '外卖红包、打车券、电影票等日常生活消费优惠券合集',
    icon: 'ri-coupon-line',
  },
  {
    id: 'shuma-3c',
    name: '数码3C',
    slug: 'shuma-3c',
    description: '手机、电脑、耳机等数码产品超值优惠与以旧换新补贴',
    icon: 'ri-smartphone-line',
  },
  {
    id: 'meishi-yinpin',
    name: '美食饮品',
    slug: 'meishi-yinpin',
    description: '奶茶咖啡、零食糕点、生鲜果蔬超值团购与优惠券',
    icon: 'ri-restaurant-line',
  },
  {
    id: 'meizhuang-hufu',
    name: '美妆护肤',
    slug: 'meizhuang-hufu',
    description: '大牌美妆护肤超值套装、小样试用、限时折扣专场',
    icon: 'ri-magic-line',
  },
  {
    id: 'jiaju-shenghuo',
    name: '家居生活',
    slug: 'jiaju-shenghuo',
    description: '家居日用、收纳清洁、家纺布艺等实用好物超值福利',
    icon: 'ri-home-heart-line',
  },
];

export const articles = [
  {
    id: 'article-1',
    slug: '2025-shuang11-chaozhi-gonglue',
    title: '2025双十一超值攻略：这样买省下一部手机钱',
    excerpt: '双十一大促即将来临，如何在这场购物狂欢中精准薅羊毛？本文整理了最全的双十一省钱攻略，从预售玩法到红包领取，手把手教你省钱技巧。',
    content: `<p>一年一度的双十一购物狂欢节又要来了！作为全年最大的购物节日，各大电商平台纷纷推出令人眼花缭乱的优惠活动。面对如此繁多的促销信息，如何才能做到真正省钱而不是被套路？今天福利铺子就为大家带来一份超详细的双十一省钱攻略。</p>
    <h2>一、提前做好购物清单</h2>
    <p>双十一期间最容易犯的错误就是冲动消费。建议提前一周列好购物清单，明确自己真正需要什么，避免被各种促销信息带偏。将商品按"刚需""想买""可买可不买"分类，优先满足刚需商品。</p>
    <h2>二、掌握预售节奏</h2>
    <p>双十一的预售通常提前半个月开始，预售商品往往有专属优惠和赠品。但要注意，预售定金一般是不可退的，下单前一定要确认好商品是否真的需要。同时，预售商品通常需要等到正式开售后付尾款，记得设置提醒避免错过。</p>
    <h2>三、善用平台红包和津贴</h2>
    <p>各大平台在双十一期间都会发放大量红包和购物津贴。包括每日签到红包、店铺优惠券、平台跨店满减券等。建议提前关注心仪店铺，领取店铺优惠券。同时，跨店满减券可以叠加使用，合理凑单能最大化优惠力度。</p>
    <h2>四、关注福利铺子实时优惠</h2>
    <p>福利铺子会在双十一期间实时更新各大平台的最优惠信息，包括隐藏优惠券、限时秒杀、品牌闪购等。关注福利铺子，让你不错过任何一个省钱机会！</p>
    <h2>五、比价工具用起来</h2>
    <p>双十一前很多商品会先涨价再降价，使用比价工具查看历史价格走势，避免被虚假折扣欺骗。同时，不同平台同一商品的价格可能有差异，货比三家再下单。</p>`,
    categoryId: 'gouwu-fanxian',
    categoryName: '购物返现',
    coverImage: 'https://readdy.ai/api/search-image?query=Warm%20orange%20and%20gold%20shopping%20festival%20scene%20with%20shopping%20bags%20and%20discount%20tags%2C%20festive%20atmosphere%2C%20clean%20minimal%20background%20with%20soft%20warm%20lighting%2C%20lifestyle%20photography%20style%2C%20cozy%20and%20inviting%20mood&width=800&height=450&seq=article-cover-01&orientation=landscape',
    author: '福利铺子编辑部',
    publishedAt: '2025-10-25',
    readTime: '8分钟',
    tags: ['双十一', '省钱攻略', '购物返现', '优惠汇总'],
  },
  {
    id: 'article-2',
    slug: 'meituan-waimai-hongbao-lingqu-jiqiao',
    title: '美团外卖红包领取全攻略：每天省出一杯奶茶钱',
    excerpt: '外卖已经成为日常生活的一部分，如何每天都能领到美团外卖红包？本文分享5个稳定领取外卖红包的渠道和技巧，让你每单都能省。',
    content: `<p>点外卖已经成为许多上班族和学生党的日常，但你是否知道，通过一些简单的方法，每天都能稳定领取外卖红包，每单至少省下3-10元？今天福利铺子就来分享几个靠谱的外卖红包领取渠道。</p>
    <h2>一、美团外卖会员月卡</h2>
    <p>开通美团外卖会员月卡是最直接的省钱方式。会员每月可获得多张5元无门槛红包，对于经常点外卖的朋友来说，会员费的投入很快就能回本。而且会员还能享受专属折扣价和优先配送等权益。</p>
    <h2>二、每日签到领红包</h2>
    <p>美团外卖APP内设有每日签到功能，连续签到天数越多，红包金额越大。建议设置每日提醒，养成签到习惯。同时，每周还有周末专属红包可以领取。</p>
    <h2>三、邀请好友得红包</h2>
    <p>通过美团外卖的邀请有礼活动，邀请新用户注册并下单，你和好友都能获得红包奖励。这是获取大额红包的有效途径，尤其是在节假日期间，邀请奖励往往更高。</p>
    <h2>四、银行信用卡优惠</h2>
    <p>多家银行信用卡与美团外卖有合作，使用指定银行卡支付可享受满减优惠。例如招商银行、交通银行等经常推出外卖满20减5、满30减8等活动。建议关注银行APP内的优惠信息。</p>
    <h2>五、福利铺子专属渠道</h2>
    <p>福利铺子会持续收集和整理各类外卖红包领取链接和优惠码，用户可以一键领取。我们还会在每周一推送本周外卖优惠汇总，让你不错过任何一个省钱机会。</p>`,
    categoryId: 'shenghuo-youhui',
    categoryName: '生活优惠',
    coverImage: 'https://readdy.ai/api/search-image?query=Warm%20toned%20food%20delivery%20scene%20with%20takeout%20boxes%20and%20smartphone%20showing%20coupons%2C%20cozy%20home%20setting%2C%20soft%20natural%20lighting%2C%20lifestyle%20photography%20with%20clean%20composition&width=800&height=450&seq=article-cover-02&orientation=landscape',
    author: '福利铺子编辑部',
    publishedAt: '2025-10-20',
    readTime: '6分钟',
    tags: ['外卖红包', '美团优惠', '生活省钱', '每日福利'],
  },
  {
    id: 'article-3',
    slug: 'aiqiyi-youku-tengxun-huiyuan-zuidi-jia',
    title: '爱奇艺优酷腾讯视频会员最低价入手攻略',
    excerpt: '追剧党必看！视频会员年年涨价，但总有隐藏低价渠道。本文整理了爱奇艺、优酷、腾讯视频等主流平台会员的最优购买方案。',
    content: `<p>视频会员价格年年攀升，很多追剧党直呼"看不起"。但其实各大视频平台经常有隐藏的优惠活动，通过正确的购买渠道，会员价格可以低至官方标价的3-5折。福利铺子今天就为大家揭秘视频会员低价入手的方法。</p>
    <h2>一、联合会员超值套餐</h2>
    <p>各大平台经常推出联合会员套餐，比如京东PLUS+爱奇艺、淘宝88VIP+优酷等，价格远低于单独购买。如果你恰好需要其中一项服务，联合会员是最划算的选择。以京东PLUS+爱奇艺年卡为例，总价约198元，相当于单独购买的5折。</p>
    <h2>二、大促节点入手</h2>
    <p>618、双十一、双十二等大促期间，视频会员通常会有全年最低价。此外，各平台周年庆也是入手的好时机。建议提前加入购物车，设置降价提醒。</p>
    <h2>三、新用户首购特惠</h2>
    <p>如果你是新用户，各平台都有极具诱惑力的首购优惠。部分平台新用户连续包月首月仅需1元。但要注意连续包月会自动续费，记得在不需要时及时取消。</p>
    <h2>四、信用卡积分兑换</h2>
    <p>多家银行信用卡积分可以兑换视频会员月卡或季卡。如果你平时有积累信用卡积分，不妨查看一下积分商城，可能会有惊喜发现。</p>
    <h2>五、福利铺子会员专区</h2>
    <p>福利铺子会员专区定期上架各大视频平台会员折扣兑换码，价格低至官方渠道的3折。关注福利铺子，第一时间获取会员优惠信息！</p>`,
    categoryId: 'huiyuan-tequan',
    categoryName: '会员特权',
    coverImage: 'https://readdy.ai/api/search-image?query=Warm%20lighting%20cozy%20living%20room%20with%20large%20TV%20screen%20showing%20streaming%20service%2C%20popcorn%20and%20drinks%20on%20coffee%20table%2C%20comfortable%20sofa%2C%20soft%20warm%20tones%2C%20lifestyle%20photography&width=800&height=450&seq=article-cover-03&orientation=landscape',
    author: '福利铺子编辑部',
    publishedAt: '2025-10-15',
    readTime: '7分钟',
    tags: ['视频会员', '会员特权', '省钱技巧', '追剧福利'],
  },
  {
    id: 'article-4',
    slug: 'iPhone-16-yijiuhuanxin-butie-zhengce',
    title: 'iPhone 16以旧换新补贴政策详解：最高可抵5000元',
    excerpt: '苹果官方以旧换新叠加电商平台补贴，换新iPhone 16竟然能省这么多！本文详细解读各渠道以旧换新政策和补贴力度。',
    content: `<p>iPhone 16系列发布后，很多果粉都在考虑换新。除了直接购买，以旧换新是一个非常划算的选择。目前苹果官方、京东、天猫等多个渠道都推出了以旧换新补贴政策，最高可抵扣5000元以上。福利铺子帮大家整理了最全面的换新攻略。</p>
    <h2>一、苹果官方以旧换新</h2>
    <p>苹果官方提供Apple Trade In换购计划，用旧iPhone折抵新机费用。iPhone 15 Pro Max最高可折抵约4500元。官方渠道的优势是流程简单、估价透明，且在购买新机时直接抵扣，无需等待。</p>
    <h2>二、京东以旧换新补贴</h2>
    <p>京东平台在以旧换新基础上额外提供补贴，通常为旧机评估价的10%-20%作为额外补贴。同时，京东还会不定期发放换新专属优惠券，可以叠加使用。以iPhone 15 Pro Max换iPhone 16 Pro Max为例，总抵扣金额可超过5000元。</p>
    <h2>三、天猫以旧换新</h2>
    <p>天猫的以旧换新政策与京东类似，但补贴力度和活动时间有所不同。建议在两家平台都进行估价，选择抵扣更高的渠道下单。天猫88VIP会员在换新时还能享受额外优惠。</p>
    <h2>四、运营商合约机换新</h2>
    <p>中国移动、中国联通、中国电信三大运营商也推出了iPhone 16合约机以旧换新活动。如果你不介意合约绑定，运营商渠道的换新补贴往往是最高的，但需要仔细计算合约期内的总花费是否划算。</p>
    <h2>五、换新注意事项</h2>
    <p>以旧换新前，请务必做好数据备份并退出Apple ID。旧机的外观成色会直接影响估价，建议使用保护壳保持手机完好。另外，不同渠道的估价标准不同，建议多平台比价后再做决定。</p>`,
    categoryId: 'shuma-3c',
    categoryName: '数码3C',
    coverImage: 'https://readdy.ai/api/search-image?query=Warm%20minimal%20product%20photography%20of%20smartphone%20on%20wooden%20desk%20with%20trade-in%20concept%2C%20soft%20golden%20lighting%2C%20clean%20background%2C%20modern%20tech%20lifestyle%20aesthetic&width=800&height=450&seq=article-cover-04&orientation=landscape',
    author: '福利铺子编辑部',
    publishedAt: '2025-10-10',
    readTime: '6分钟',
    tags: ['iPhone 16', '以旧换新', '数码优惠', '苹果福利'],
  },
  {
    id: 'article-5',
    slug: 'xingbake-ruixing-chaoyandao-kafei-youhui',
    title: '星巴克瑞幸超言道咖啡优惠大比拼：谁家最划算？',
    excerpt: '咖啡爱好者福音！我们横向对比了星巴克、瑞幸、超言道三大咖啡品牌的优惠活动和会员体系，帮你找到最适合自己的咖啡省钱方案。',
    content: `<p>每天一杯咖啡已经成为很多都市白领的生活方式。星巴克、瑞幸、超言道三足鼎立，各有各的优惠策略。到底哪家最划算？福利铺子做了详细对比，帮你做出最优选择。</p>
    <h2>一、星巴克优惠策略</h2>
    <p>星巴克的会员体系分为银星、玉星、金星三个等级，消费累积星星可升级。金星会员享有买三赠一、生日饮品等权益。此外，星巴克经常推出银行卡满减活动，如招商银行周五满60减20等。综合来看，星巴克的单杯成本约25-35元。</p>
    <h2>二、瑞幸咖啡优惠策略</h2>
    <p>瑞幸以高性价比著称，通过APP内优惠券和拼单活动，单杯价格可低至9.9元。瑞幸的"每日特价"和"买二送一"活动频繁，加上新用户首杯免费等福利，是性价比最高的选择之一。但需注意部分优惠券有使用时段限制。</p>
    <h2>三、超言道咖啡优惠策略</h2>
    <p>超言道定位介于星巴克和瑞幸之间，主打精品咖啡品质+亲民价格。会员体系采用储值优惠模式，充值赠送金额相当于8折左右。此外，超言道经常与各大银行合作推出支付满减活动，叠加会员折扣后单杯约15-25元。</p>
    <h2>四、综合推荐</h2>
    <p>如果你追求极致性价比，瑞幸是最优选择；如果注重品质和环境体验，星巴克更合适；超言道则是平衡之选。建议下载三家APP，根据当天优惠情况灵活选择。福利铺子会持续更新咖啡优惠信息，助你每天喝到最划算的咖啡！</p>`,
    categoryId: 'meishi-yinpin',
    categoryName: '美食饮品',
    coverImage: 'https://readdy.ai/api/search-image?query=Warm%20cozy%20coffee%20shop%20scene%20with%20three%20different%20coffee%20cups%20on%20wooden%20table%2C%20soft%20natural%20light%20from%20window%2C%20minimal%20clean%20composition%2C%20lifestyle%20photography%20with%20warm%20tones&width=800&height=450&seq=article-cover-05&orientation=landscape',
    author: '福利铺子编辑部',
    publishedAt: '2025-10-05',
    readTime: '5分钟',
    tags: ['咖啡优惠', '星巴克', '瑞幸', '美食福利'],
  },
  {
    id: 'article-6',
    slug: 'lancome-yashilan-dai-xianglian-shuang11-chaozhi-tao',
    title: '兰蔻雅诗兰黛双十一超值套装怎么选？看完省500',
    excerpt: '双十一大牌美妆超值套装让人眼花缭乱，兰蔻小黑瓶、雅诗兰黛小棕瓶哪个套装最值得买？我们帮你对比分析。',
    content: `<p>每年双十一，各大美妆品牌的超值套装都是抢购焦点。兰蔻和雅诗兰黛作为最受欢迎的两大高端护肤品牌，今年的双十一套装诚意满满。福利铺子帮大家做了详细对比，让你不花冤枉钱。</p>
    <h2>一、兰蔻双十一超值套装</h2>
    <p>兰蔻今年主推小黑瓶精华肌底液套装，包含正装50ml小黑瓶+20ml中样+5ml小样+极光水50ml+面霜15ml，总价值超过2000元，双十一预售价仅1080元。相当于5折入手，还赠送精美化妆包。同时，兰蔻菁纯系列也有满赠活动，满1280元赠价值580元的菁纯五件套。</p>
    <h2>二、雅诗兰黛双十一超值套装</h2>
    <p>雅诗兰黛主推小棕瓶精华套装，包含正装50ml小棕瓶+15ml中样+智妍面霜30ml+眼部精华5ml，总价值约1900元，双十一预售价980元。此外，雅诗兰黛DW粉底液也有买一送一活动，非常划算。</p>
    <h2>三、如何选择</h2>
    <p>如果你注重抗老修复，兰蔻小黑瓶+菁纯系列是不错的选择；如果你更关注保湿维稳，雅诗兰黛小棕瓶+智妍系列更适合。建议根据自己肤质和需求来选择，不要盲目跟风。同时，两家都有预售加赠活动，建议第一时间下单锁定赠品。</p>
    <h2>四、福利铺子专属福利</h2>
    <p>通过福利铺子专属链接下单，还可额外获得我们准备的护肤小样礼包。关注福利铺子美妆频道，获取更多大牌美妆优惠信息！</p>`,
    categoryId: 'meizhuang-hufu',
    categoryName: '美妆护肤',
    coverImage: 'https://readdy.ai/api/search-image?query=Warm%20elegant%20beauty%20skincare%20product%20photography%20with%20luxury%20cosmetic%20bottles%20on%20marble%20surface%2C%20soft%20golden%20lighting%2C%20rose%20petals%2C%20minimal%20clean%20aesthetic%2C%20premium%20brand%20feel&width=800&height=450&seq=article-cover-06&orientation=landscape',
    author: '福利铺子编辑部',
    publishedAt: '2025-09-28',
    readTime: '7分钟',
    tags: ['美妆护肤', '双十一', '兰蔻', '雅诗兰黛'],
  },
  {
    id: 'article-7',
    slug: 'muji-ikea-shoujia-gongju-youhui-dadui-bi',
    title: 'MUJI无印良品vs宜家收纳好物优惠对比',
    excerpt: '换季收纳正当时！MUJI和宜家谁的收纳产品性价比更高？我们实地对比了两大品牌的收纳系列，附上当前优惠信息。',
    content: `<p>换季时节，收纳整理成了很多家庭的刚需。MUJI无印良品和宜家是收纳品类中最受欢迎的两个品牌，但风格和价格差异明显。福利铺子实地探店，为大家带来最全面的对比测评和优惠信息。</p>
    <h2>一、MUJI收纳系列</h2>
    <p>MUJI的收纳产品以极简设计和优良品质著称，PP收纳盒系列是当家花旦。MUJI收纳盒采用半透明设计，内容物一目了然，且可以自由叠放组合。价格方面，中号PP收纳盒约58元，大号约88元。目前MUJI正在进行会员折扣活动，满300减40，满500减80。</p>
    <h2>二、宜家收纳系列</h2>
    <p>宜家的收纳产品线更加丰富，从KUGGIS到SAMLA系列，覆盖各种尺寸和价位。宜家收纳盒以高性价比见长，KUGGIS系列中号收纳盒仅29.9元。宜家目前有"新居收纳季"活动，收纳品类满299减50，并有多款热销收纳产品参与限时特价。</p>
    <h2>三、各场景推荐</h2>
    <p>桌面收纳和化妆品收纳推荐MUJI，设计和质感更胜一筹；衣柜和大件收纳推荐宜家，容量大且性价比高；厨房收纳两者各有千秋，MUJI更适合开放式收纳，宜家更适合柜内整理。</p>
    <h2>四、省钱小贴士</h2>
    <p>MUJI建议趁会员日入手，宜家建议关注季节性促销。另外，两家官网和线下门店的优惠活动有时不同步，下单前最好对比一下。福利铺子会持续更新家居收纳优惠，帮你打造整洁舒适的家！</p>`,
    categoryId: 'jiaju-shenghuo',
    categoryName: '家居生活',
    coverImage: 'https://readdy.ai/api/search-image?query=Warm%20minimal%20home%20organization%20scene%20with%20storage%20boxes%20and%20baskets%20on%20wooden%20shelves%2C%20soft%20natural%20lighting%2C%20clean%20and%20tidy%20aesthetic%2C%20cozy%20Scandinavian%20style%20interior&width=800&height=450&seq=article-cover-07&orientation=landscape',
    author: '福利铺子编辑部',
    publishedAt: '2025-09-22',
    readTime: '5分钟',
    tags: ['家居生活', '收纳好物', 'MUJI', '宜家'],
  },
  {
    id: 'article-8',
    slug: 'didi-chuxing-youhui-juan-lingqu-fangfa',
    title: '滴滴出行优惠券领取全渠道汇总：通勤党每月省200',
    excerpt: '每天打车上下班，一年下来是一笔不小的开销。本文整理了滴滴出行所有可领取优惠券的渠道，帮你大幅降低通勤成本。',
    content: `<p>对于每天需要打车通勤的上班族来说，交通费是一笔不可忽视的支出。其实通过合理利用各种优惠券，每月至少能省下200元。福利铺子整理了滴滴出行所有领券渠道，通勤党建议收藏！</p>
    <h2>一、滴滴APP内领券</h2>
    <p>滴滴APP首页每周都会更新优惠券包，包括快车券、专车券、顺风车券等。工作日早上8-10点使用快车通勤，经常能领到8折或满减券。此外，滴滴会员等级越高，每月领取的优惠券越多。</p>
    <h2>二、支付宝出行频道</h2>
    <p>支付宝首页的"出行"频道也是领取滴滴优惠券的重要渠道。每周三为支付宝出行日，当天可领取专属大额优惠券。使用支付宝支付车费还能累积蚂蚁会员积分。</p>
    <h2>三、银行信用卡合作</h2>
    <p>招商银行、浦发银行等多家银行与滴滴有深度合作，使用指定信用卡支付可享受立减优惠。例如招商银行young卡每周五首单立减5元，浦发银行滴滴卡每月最高返现60元。</p>
    <h2>四、企业滴滴福利</h2>
    <p>很多公司与滴滴企业版有合作，员工可享受企业折扣价。如果你的公司还没有开通这项福利，可以向HR建议。企业滴滴通常比个人叫车便宜10%-20%。</p>
    <h2>五、福利铺子专属出行福利</h2>
    <p>福利铺子定期更新滴滴出行优惠券包领取链接，用户可一键领取。此外，我们还会在每月初汇总当月出行优惠信息，帮你规划最省钱的出行方式。</p>`,
    categoryId: 'shenghuo-youhui',
    categoryName: '生活优惠',
    coverImage: 'https://readdy.ai/api/search-image?query=Warm%20urban%20commute%20scene%20with%20smartphone%20showing%20ride-hailing%20app%20and%20city%20street%20background%2C%20soft%20golden%20hour%20lighting%2C%20modern%20lifestyle%20photography%2C%20clean%20composition&width=800&height=450&seq=article-cover-08&orientation=landscape',
    author: '福利铺子编辑部',
    publishedAt: '2025-09-18',
    readTime: '6分钟',
    tags: ['滴滴出行', '出行优惠', '通勤省钱', '生活福利'],
  },
];

export const faqs = [
  {
    id: 'faq-1',
    question: '福利铺子是什么？',
    answer: '福利铺子是一个聚合全网福利优惠的一站式平台。我们每天精选海量福利资源，涵盖购物返现、限时秒杀、会员特权、生活优惠等各类省钱福利，帮助用户轻松发现好物优惠，享受实实在在的省钱体验。',
  },
  {
    id: 'faq-2',
    question: '如何在福利铺子领取优惠券？',
    answer: '在福利铺子网站上，浏览您感兴趣的福利分类或文章，点击优惠券链接即可跳转至对应平台领取。部分专属优惠券需要通过福利铺子的专属链接才能激活，请确保从福利铺子页面点击进入。',
  },
  {
    id: 'faq-3',
    question: '福利铺子的优惠信息更新频率是怎样的？',
    answer: '福利铺子团队每天实时监控各大平台的优惠信息，保持每日更新。限时秒杀类福利会在活动开始前24小时内发布，常规优惠每周汇总更新。建议关注福利铺子首页的"最新福利"板块，第一时间获取最新优惠。',
  },
  {
    id: 'faq-4',
    question: '福利铺子的优惠券是否真实有效？',
    answer: '福利铺子所有发布的优惠信息均经过人工审核验证，确保真实有效。我们与多家品牌和平台建立了合作关系，部分为福利铺子用户专属优惠。如果遇到优惠券无法使用的情况，请及时联系我们，我们会尽快核实更新。',
  },
  {
    id: 'faq-5',
    question: '如何在福利铺子发布优惠信息？',
    answer: '如果您是品牌方或商家，希望与福利铺子合作发布优惠信息，请通过"关于我们"页面的联系方式与我们取得联系。我们的商务团队会在1-2个工作日内回复您，洽谈合作事宜。',
  },
  {
    id: 'faq-6',
    question: '福利铺子是否需要注册账号？',
    answer: '目前福利铺子无需注册即可浏览所有优惠信息。我们致力于为用户提供最便捷的省钱体验，未来我们会推出会员系统，注册用户可享受专属福利和个性化推荐等增值服务。',
  },
  {
    id: 'faq-7',
    question: '通过福利铺子购物安全吗？',
    answer: '福利铺子本身不直接销售商品，我们提供的是优惠信息和跳转链接。您最终是在京东、淘宝、拼多多等正规电商平台完成交易，享受平台提供的消费者保障服务，购物安全有保障。',
  },
  {
    id: 'faq-8',
    question: '如何使用福利铺子的搜索功能？',
    answer: '您可以在福利铺子网站顶部导航栏找到搜索入口，输入关键词（如品牌名、商品名、优惠类型）即可快速找到相关福利信息。我们也提供了分类浏览功能，帮助您按类别精准查找优惠。',
  },
];

export const testimonials = [
  {
    id: 'testimonial-1',
    name: '小陈',
    avatar: 'https://readdy.ai/api/search-image?query=Warm%20professional%20portrait%20of%20young%20Asian%20woman%20smiling%2C%20soft%20natural%20lighting%2C%20clean%20minimal%20background%2C%20friendly%20approachable%20look&width=100&height=100&seq=avatar-01&orientation=squarish',
    role: '职场白领',
    content: '自从关注了福利铺子，每个月外卖和咖啡钱至少省了200块！特别推荐他们的每日福利汇总，一打开就知道今天有哪些优惠可以领。',
    rating: 5,
  },
  {
    id: 'testimonial-2',
    name: '大刘',
    avatar: 'https://readdy.ai/api/search-image?query=Warm%20professional%20portrait%20of%20young%20Asian%20man%20with%20friendly%20smile%2C%20soft%20natural%20lighting%2C%20clean%20minimal%20background%2C%20approachable%20look&width=100&height=100&seq=avatar-02&orientation=squarish',
    role: '数码发烧友',
    content: '去年双十一通过福利铺子的攻略，买iPhone省了将近800块！他们的价格对比和以旧换新攻略做得特别详细，数码党必看。',
    rating: 5,
  },
  {
    id: 'testimonial-3',
    name: '小王',
    avatar: 'https://readdy.ai/api/search-image?query=Warm%20professional%20portrait%20of%20young%20Asian%20woman%20with%20gentle%20smile%2C%20soft%20natural%20lighting%2C%20clean%20minimal%20background%2C%20friendly%20look&width=100&height=100&seq=avatar-03&orientation=squarish',
    role: '全职妈妈',
    content: '作为精打细算的全职妈妈，福利铺子就是我的省钱神器！家居日用、美妆护肤的优惠信息特别全，每次大促前看看攻略，能省不少钱。',
    rating: 5,
  },
  {
    id: 'testimonial-4',
    name: '阿杰',
    avatar: 'https://readdy.ai/api/search-image?query=Warm%20professional%20portrait%20of%20young%20Asian%20man%20with%20confident%20smile%2C%20soft%20natural%20lighting%2C%20clean%20minimal%20background%2C%20friendly%20vibe&width=100&height=100&seq=avatar-04&orientation=squarish',
    role: '大学生',
    content: '学生党预算有限，福利铺子的会员优惠和秒杀信息太实用了！视频会员、外卖红包这些刚需福利帮我省了不少生活费。',
    rating: 5,
  },
];

export const hotDeals = [
  {
    id: 'deal-1',
    title: '京东PLUS+爱奇艺联合年卡',
    description: '京东PLUS会员年卡与爱奇艺黄金VIP年卡联合套餐，超值组合价',
    originalPrice: 396,
    currentPrice: 198,
    discount: '5折',
    category: 'huiyuan-tequan',
    categoryName: '会员特权',
    image: 'https://readdy.ai/api/search-image?query=Warm%20minimal%20product%20photography%20of%20streaming%20service%20and%20shopping%20membership%20cards%20on%20clean%20surface%2C%20soft%20golden%20lighting%2C%20simple%20elegant%20composition&width=600&height=400&seq=deal-img-01&orientation=landscape',
    tag: '限时特惠',
    expiresIn: '3天后结束',
  },
  {
    id: 'deal-2',
    title: '美团外卖会员月卡',
    description: '开通即享6张5元无门槛红包，新用户首月特惠价',
    originalPrice: 15,
    currentPrice: 5.9,
    discount: '3.9折',
    category: 'shenghuo-youhui',
    categoryName: '生活优惠',
    image: 'https://readdy.ai/api/search-image?query=Warm%20cozy%20food%20delivery%20concept%20with%20smartphone%20showing%20coupons%20and%20takeout%20bags%2C%20soft%20natural%20lighting%2C%20lifestyle%20photography%2C%20clean%20minimal%20background&width=600&height=400&seq=deal-img-02&orientation=landscape',
    tag: '新用户专享',
    expiresIn: '长期有效',
  },
  {
    id: 'deal-3',
    title: '兰蔻小黑瓶精华50ml套装',
    description: '含正装+中样+小样+极光水+面霜，赠精美化妆包',
    originalPrice: 2080,
    currentPrice: 1080,
    discount: '5.2折',
    category: 'meizhuang-hufu',
    categoryName: '美妆护肤',
    image: 'https://readdy.ai/api/search-image?query=Warm%20elegant%20luxury%20skincare%20product%20set%20on%20marble%20surface%20with%20soft%20golden%20lighting%2C%20minimal%20clean%20aesthetic%2C%20premium%20beauty%20photography&width=600&height=400&seq=deal-img-03&orientation=landscape',
    tag: '双十一预售',
    expiresIn: '5天后结束',
  },
  {
    id: 'deal-4',
    title: '星巴克买一赠一券',
    description: '指定时段使用，适用于所有手工调制饮品',
    originalPrice: 38,
    currentPrice: 0,
    discount: '免费领',
    category: 'meishi-yinpin',
    categoryName: '美食饮品',
    image: 'https://readdy.ai/api/search-image?query=Warm%20cozy%20coffee%20photography%20with%20two%20coffee%20cups%20on%20wooden%20table%2C%20soft%20morning%20light%2C%20minimal%20cafe%20aesthetic%2C%20inviting%20atmosphere&width=600&height=400&seq=deal-img-04&orientation=landscape',
    tag: '限时领取',
    expiresIn: '今日截止',
  },
  {
    id: 'deal-5',
    title: 'iPhone 16 以旧换新补贴',
    description: '旧机抵扣+平台额外补贴，最高可省5000元',
    originalPrice: 7999,
    currentPrice: 2999,
    discount: '抵5000',
    category: 'shuma-3c',
    categoryName: '数码3C',
    image: 'https://readdy.ai/api/search-image?query=Warm%20modern%20smartphone%20on%20wooden%20desk%20with%20trade-in%20concept%2C%20soft%20golden%20lighting%2C%20minimal%20tech%20lifestyle%20photography%2C%20clean%20composition&width=600&height=400&seq=deal-img-05&orientation=landscape',
    tag: '超值换新',
    expiresIn: '15天后结束',
  },
  {
    id: 'deal-6',
    title: 'MUJI收纳盒三件套',
    description: 'PP材质半透明设计，可自由叠放，三件组合优惠',
    originalPrice: 174,
    currentPrice: 99,
    discount: '5.7折',
    category: 'jiaju-shenghuo',
    categoryName: '家居生活',
    image: 'https://readdy.ai/api/search-image?query=Warm%20minimal%20home%20organization%20with%20storage%20boxes%20on%20wooden%20shelf%2C%20soft%20natural%20lighting%2C%20clean%20Scandinavian%20interior%20style%2C%20tidy%20aesthetic&width=600&height=400&seq=deal-img-06&orientation=landscape',
    tag: '会员专享',
    expiresIn: '7天后结束',
  },
  {
    id: 'deal-7',
    title: '滴滴出行5元无门槛券',
    description: '每日限量领取，适用于快车、特惠快车',
    originalPrice: 5,
    currentPrice: 0,
    discount: '免费领',
    category: 'shenghuo-youhui',
    categoryName: '生活优惠',
    image: 'https://readdy.ai/api/search-image?query=Warm%20urban%20commute%20scene%20with%20smartphone%20showing%20ride-hailing%20app%20and%20taxi%2C%20soft%20golden%20hour%20lighting%2C%20modern%20city%20lifestyle%20photography&width=600&height=400&seq=deal-img-07&orientation=landscape',
    tag: '每日限量',
    expiresIn: '今日领完即止',
  },
  {
    id: 'deal-8',
    title: '瑞幸咖啡9.9元任选券',
    description: '全场饮品通用，每日限量发放，新老用户均可领取',
    originalPrice: 29,
    currentPrice: 9.9,
    discount: '3.4折',
    category: 'meishi-yinpin',
    categoryName: '美食饮品',
    image: 'https://readdy.ai/api/search-image?query=Warm%20cozy%20coffee%20shop%20scene%20with%20latte%20art%20coffee%20cup%20on%20wooden%20table%2C%20soft%20morning%20lighting%2C%20minimal%20cafe%20aesthetic%2C%20inviting%20atmosphere&width=600&height=400&seq=deal-img-08&orientation=landscape',
    tag: '手慢无',
    expiresIn: '今日截止',
  },
];